/**
 * Base URL of the Docsight backend.
 *
 * Supplied by `VITE_API_BASE_URL` (see `.env.example`); Vite inlines it at
 * build time. Any trailing slash is trimmed so callers can always join paths
 * as `${API_BASE_URL}/healthz`.
 */
export const API_BASE_URL: string = (import.meta.env.VITE_API_BASE_URL ?? '').replace(/\/+$/, '');

/**
 * Base URL of the Docsight MCP server, which speaks its own protocol on its own
 * port and so cannot be derived from {@link API_BASE_URL}. Supplied by
 * `VITE_MCP_BASE_URL`; shown on Settings → Sources so an integrator can point a
 * client at it.
 */
export const MCP_BASE_URL: string = (import.meta.env.VITE_MCP_BASE_URL ?? '').replace(/\/+$/, '');
